import { Skeleton } from "@/components/ui/skeleton"

export function PageSkeleton() {
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {Array.from({ length: 6 }, (_, i) => (
          <Skeleton key={i} className="h-20" />
        ))}
      </div>
      <Skeleton className="h-28" />
      <Skeleton className="h-64" />
    </div>
  )
}

export function FetchError({
  error,
  retry,
}: {
  error: unknown
  retry: () => void
}) {
  const message = error instanceof Error ? error.message : String(error)
  return (
    <div className="border border-border bg-card px-4 py-6">
      <p className="font-mono text-xs uppercase tracking-[0.14em] text-muted-foreground">
        console api unreachable
      </p>
      <p className="mt-2 font-mono text-sm" style={{ color: "var(--viz-failed)" }}>
        {message}
      </p>
      <p className="mt-2 text-sm text-muted-foreground">
        Check that the brain is running and BRAIN_DEV_AUTH=true is set for
        local development, then retry.
      </p>
      <button
        onClick={retry}
        className="mt-3 border border-border bg-background px-3 py-1.5 font-mono text-xs hover:bg-accent focus-visible:outline-2 focus-visible:outline-ring"
      >
        retry
      </button>
    </div>
  )
}
